var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-table",
        {
          class:
            _vm.otrosDocumentos.length > 0
              ? "cursor-pointer"
              : "cursor-default",
          attrs: {
            data: _vm.otrosDocumentos,
            bordered: false,
            narrowed: false,
            hoverable: true,
            loading: _vm.isLoading,
            checkable: "",
            "checked-rows": _vm.selectedOtrosDocumentos,
            "mobile-cards": true,
            sortable: true,
          },
          on: { dblclick: _vm.goToDocument, check: _vm.checkRow },
          scopedSlots: _vm._u([
            {
              key: "empty",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "is-family-monospace has-text-centered" },
                    [
                      _vm.isLoading
                        ? _c("span")
                        : _c("span", [
                            _vm._v(
                              _vm._s(_vm.Constants.STRINGS.LISTS.NO_RESULTS)
                            ),
                          ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("b-table-column", {
            attrs: {
              field: "nombre",
              label: _vm.Constants.STRINGS.TABLES.HEADERS.DOCUMENTS.DOCUMENTS,
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("span", { staticClass: "break-word" }, [
                      _c("i", { staticClass: "fas fa-file" }),
                      _vm._v("  " + _vm._s(props.row.nombre)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          this.tieneRolAdminOLyris
            ? _c("b-table-column", {
                attrs: {
                  field: "otro_documento_usuario",
                  sortable: "",
                  label: _vm.Constants.STRINGS.TABLES.HEADERS.DOCUMENTS.SCOPE,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _vm.howManyReceivers(props.row) > 1
                            ? _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    multilined: "",
                                    size:
                                      _vm.howManyReceivers(props.row) > 3
                                        ? "is-large"
                                        : "is-medium",
                                    label: _vm.getMultipleScopeTooltipText(
                                      props.row
                                    ),
                                  },
                                },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      pack: "fas",
                                      icon: _vm.getMultipleScopeIcon(props.row),
                                    },
                                  }),
                                  _vm._v(
                                    "\n        " +
                                      _vm._s(
                                        _vm.getMultipleScopeText(props.row)
                                      ) +
                                      "\n      "
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      pack: "fas",
                                      icon: _vm.getSingleScopeIcon(props.row),
                                    },
                                  }),
                                  _vm._v(
                                    "\n        " +
                                      _vm._s(
                                        _vm.getSingleScopeText(props.row)
                                      ) +
                                      "\n      "
                                  ),
                                ],
                                1
                              ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1936011165
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: {
              field: "estado",
              label: _vm.Constants.STRINGS.TABLES.HEADERS.DOCUMENTS.SIGN_STATE,
              sortable: "",
              centered: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm.isAvailableStatus(props.row.estado)
                      ? _c("div", [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.Constants.STRINGS.LISTS.NOT_AVAILABLE
                              ) +
                              "\n      "
                          ),
                        ])
                      : _vm.isPendingOrSignedStatus(props.row)
                      ? _c(
                          "div",
                          [
                            _c("b-icon", {
                              attrs: {
                                pack: "fas",
                                icon: _vm.getPendingOrSignedStatusIcon(
                                  props.row.estado
                                ),
                              },
                            }),
                            _vm._v(
                              _vm._s(_vm.getStatusTextForAdmins(props.row)) +
                                "\n      "
                            ),
                          ],
                          1
                        )
                      : _c(
                          "b-tooltip",
                          {
                            attrs: {
                              multilined: "",
                              size: "is-large",
                              label: _vm.getEmployeeSignedDocumentTooltipText(
                                props.row.estado
                              ),
                            },
                          },
                          [
                            _c("b-icon", {
                              attrs: {
                                pack: "far",
                                icon: _vm.getEmployeeSignedIcon(
                                  props.row.estado
                                ),
                              },
                            }),
                            _vm._v(
                              _vm._s(_vm.getStatusTextForAdmins(props.row)) +
                                "\n      "
                            ),
                          ],
                          1
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: {
              field: "created_at",
              label: _vm.Constants.STRINGS.TABLES.HEADERS.DOCUMENTS.DATE,
              sortable: "",
              centered: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("moment")(
                            new Date(props.row.created_at),
                            "DD/MM/YYYY"
                          )
                        ) +
                        "\n    "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: {
              field: "tipo_otro_documento.nombre",
              label: _vm.Constants.STRINGS.TABLES.HEADERS.DOCUMENTS.TYPE,
              sortable: "",
              centered: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(
                      "\n      " +
                        _vm._s(props.row.tipo_otro_documento.nombre) +
                        "\n    "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "infinite-loading",
        {
          attrs: { identifier: _vm.identifierLoaderDocuments },
          on: { infinite: _vm.infiniteHandlerDocuments },
        },
        [
          _c(
            "div",
            {
              staticClass: "py-5 is-size-7 is-family-monospace",
              attrs: { slot: "no-more" },
              slot: "no-more",
            },
            [
              _vm.isLoading
                ? _c("span", [
                    _vm._v(_vm._s(_vm.Constants.STRINGS.LOADING.LOADING_TEXT)),
                  ])
                : _c("span", [
                    _vm._v(_vm._s(_vm.Constants.STRINGS.LISTS.END_OF_LIST)),
                  ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "py-5 is-size-7 is-family-monospace",
              attrs: { slot: "no-results" },
              slot: "no-results",
            },
            [
              _vm.isLoading
                ? _c("span", [
                    _vm._v(_vm._s(_vm.Constants.STRINGS.LOADING.LOADING_TEXT)),
                  ])
                : _c("span", [
                    _vm._v(_vm._s(_vm.Constants.STRINGS.LISTS.END_OF_LIST)),
                  ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }